import { useQuery } from 'react-query';
import {
  getBettieBalances,
  type GetBettieBalancesResponse
} from '../../services/bettieBalancesService';

export function useGetBettieBalances() {
  return useQuery<GetBettieBalancesResponse>(['bettieBalances'], getBettieBalances, {
    staleTime: 0,
    cacheTime: 0
  });
}
